export default "__VITE_ASSET__DiUptEI4__"